module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAAAXNSR0IArs4c6QAAAV5JREFUKBWNkrFKw1AUhr2hHTIVBAeHOBiSDnbRycFF6gOIq4IuPoEPUMTVJ9ChLS6iFAeRTk4q6CMkTVwyiZOTFNrE74TcYJJWPBDOPed897/n5F618IeNRqP1JEluQbpqHheG4cpkMnmlvqyU+jBmgUCN6XT6IFBWv6iAHFVHaYBvCYTateM4nQpIX5fU2xn0BHjEl9QkoQ2oE8fxYRb7pmnuWpY1ljgfxvM8AXppUqlP/Kbruu8Si6Ugzbfpa0hc55hv/DbQmwDajCAIWkw4ICFQzBD7ZUjgGj1dUWxIAHgCdCfrssnUeZ+ldYE1sAOUviSL8rnv+3sFIgv+P4xssG37EXcsa1RN3D3KqxJry2+m2Wz2SZ5KAXiJbxhF0aIGfw+S5lDqAenbeWaGHe56nCvqnSSlBWlFbIvf12ejqihKNXtmLwBrEvNXzmaCGVx4uHNBgXlNG6jesOz+AOSroKQNEsHCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/last_chapter.png
// module id = 0crp
// module chunks = 0